import React, { FC } from 'react'
import { Partners, usePartner } from '@shared/lib/partner'
import AutumnAnimatedBackground from './AutumnAnimatedBackground'
import PartnerAnimatedBackground from './PartnerAnimatedBackground'

const AnimatedBackground: FC = () => {
  const { partner } = usePartner()

  if (partner === Partners.DEFAULT) {
    return <AutumnAnimatedBackground />
  }

  return <PartnerAnimatedBackground />
}

export default AnimatedBackground
